<template>
<div
  class="report-data-table"
  :style="{
    'min-height': `${currentGranularity === 'day_and_night' ? '100%' : ''}`,
    'grid-template-rows': `${currentGranularity === 'day_and_night' ? '1.8em auto' : '1.8em 400px'}`
  }"
>
  <div class="report-data-table-header">
    <span>{{dataConfig.name}}</span>
    <el-link type="success" @click="onExportBtnClick">导出</el-link>
  </div>

  <div
    class="report-data-table-body"
    :style="{
      display: 'grid',
      height: `${currentGranularity === 'day_and_night' ? '100%' : ''}`,
      gap: `${currentGranularity === 'day_and_night' ? '10px' : ''}`,
      'grid-template-columns': '100%',
      'grid-template-rows': `${currentGranularity === 'day_and_night' ? '400px auto' : '400px'}`,
    }"
  >
    <div>
      <z-table
        ref="dataTable"
        :columns="headerColumns"
        :data="dataConfig.dataList"
        selected-row-style
        class="legend-table no-wrap-table"
      >
        <template v-for="(column, i) in headerColumns" :slot="column.prop" :lable="column.label" slot-scope="{row}">
          <div :key="i" :is-pass="row[column.prop + 'isPass']" class="factor-pass-value" :class="` ${row[column.prop + 'Flag'] ? 'integral-data' : 'normal-data'}`">
            {{row[column.prop]}}
          </div>
        </template>
      </z-table>
    </div>
    <div v-if="currentGranularity === 'day_and_night'">
      <day-night-line-chart
        ref="DayNightLineChart"
        :data="dataConfig"
      />
    </div>
  </div>
</div>
</template>

<script>
import CSVDownloader from '../../../utils/CSVDownloader'
import ZTable from './08VOCs-Data-Compare/ZTable'
import DayNightLineChart from '../../../components/Data/DayNightLineChart'

export default {
  name: 'ReportDataTable',
  components: {ZTable, DayNightLineChart},
  props: {
    currentQuery: {
      required: true,
      type: Object
    },
    dataConfig: {
      required: true,
      type: Object
    },
    showOfp: {
      default: false
    },
    granularity: {
      type: String
    }
  },
  data () {
    return {
      currentGranularity: this.granularity
    }
  },
  computed: {
    headerColumns () {
      let {dataConfig: {dimensions, unitProp}} = this
      // let temp = dimensions.filter(el => el.id !== 'm30000')
      let displayUnit = ''
      let stdUnit = ''
      let columns = dimensions.reduce((headerColumns, dimension) => {
        displayUnit = dimension['displayUnit']
        stdUnit = dimension['stdUnit']
        let unit = dimension[unitProp]
        headerColumns.push({
          prop: dimension.id,
          label: `${dimension.name}${unit ? `(${unit})` : ''}`,
          align: 'left'
        })
        return headerColumns
      }, [])

      if (this.showOfp) {
        columns.unshift({
          prop: 'total',
          label: 'OFP(' + (unitProp === 'displayUnit' ? displayUnit : stdUnit) + ')',
          width: 150,
          align: 'left',
          fixed: false
        })
        columns.unshift({
          prop: 'dataTime',
          label: '时间',
          width: 150,
          align: 'left',
          fixed: true
        })
        return columns
      } else {
        columns.unshift({
          prop: 'dataTime',
          label: '时间',
          width: 150,
          align: 'left',
          fixed: true
        })
        return columns
      }
    }
  },
  methods: {
    onExportBtnClick () {
      let {currentQuery: {beginTime, endTime}, headerColumns, dataConfig} = this
      let filename = `${dataConfig.name}_${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`
      CSVDownloader([headerColumns.map(column => column.label)].concat(dataConfig.dataList.map(data => headerColumns.map(column => {
        let back = ''
        if (data[column.prop + 'Flag']) {
          back = data[column.prop] + '(重积分)'
        } else {
          back = data[column.prop]
        }
        return back
      }))), filename)
    }
  },
  watch: {
    currentGranularity: {
      immediate: true,
      handler (granularity) {
        setTimeout(() => {
          if (granularity === 'day_and_night') {
            this.$refs.DayNightLineChart.render()
          }
        }, 0)
      }
    },
    dataConfig: {
      immediate: true,
      handler () {
        if (this.currentGranularity === this.granularity && this.currentGranularity === 'day_and_night') {
          clearTimeout(this.renderChartTimer)

          this.renderTimer = setTimeout(() => {
            this.$refs.dataTable.doLayout()
            this.$refs.DayNightLineChart.render()
          }, 0)
        } else {
          this.currentGranularity = this.granularity

          this.renderTimer = setTimeout(() => {
            this.$refs.dataTable.doLayout()
          }, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.report-data-table {
  display: grid;
  grid-template-rows: 1.8em 400px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .report-data-table-header {
    display: grid;
    grid-template-columns: auto max-content;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(90deg, #fbc15a 0, #fff);
    color: #ffffff;
    font-weight: 600;
  }
}
.no-wrap-table {
  --z-table-white-space: nowrap;
}
legend {
  font-size: 16px;
  padding: 0 1em;
  color: #303133;
  text-align: center;
}
.z-table {
  min-height: 0;
}
.integral-data {
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/ReportDataTable.vue